<template>
  <div class="userInfo" v-if="isLoading">
    <div class="addExperiment-title">
      <span>个人资料</span>
    </div>
    <div class="userInfo-content">
      <div class="content-title">
        <div class="content-title-left">
          <span>用户头像</span>
          <img :src="userInfo.portraitUrl" alt="" />
        </div>
        <!-- <div
          class="content-title-right"
          @click="goNextRouter('/updateUserInfo')"
        >
          <img src="@/assets/images/common/update.png" alt="" /><span
            >编辑</span
          >
        </div> -->
      </div>
      <div class="content" v-if="role == 2">
        <div class="list">
          <span>用户名称</span>
          <p>{{ noValue(userInfo.name) }}</p>
        </div>
        <div class="list">
          <span>大学名称</span>
          <p>{{ noValue(userInfo.schoolName) }}</p>
        </div>
        <div class="list">
          <span>性别</span>
          <p>{{ noValue(userInfo.sex) }}</p>
        </div>
        <div class="list">
          <span>电话</span>
          <p>{{ noValue(userInfo.phoneNumber) }}</p>
        </div>
        <div class="list">
          <span>邮箱</span>
          <p>{{ noValue(userInfo.email) }}</p>
        </div>
        <!-- <div class="list">
          <span>简介</span>
          <p>--</p>
        </div> -->
      </div>
      <div class="content" v-if="role == 1">
        <div class="list">
          <span>用户名称</span>
          <p>{{ noValue(userInfo.name) }}</p>
        </div>
        <div class="list">
          <span>昵称</span>
          <p>{{ noValue(userInfo.nickName) }}</p>
        </div>
        <div class="list">
          <span>性别</span>
          <p>{{ noValue(userInfo.sex) }}</p>
        </div>
        <div class="list">
          <span>大学</span>
          <p>{{ noValue(userInfo.schoolName) }}</p>
        </div>
        <div class="list">
          <span>学院</span>
          <p>{{ noValue(userInfo.collegeName) }}</p>
        </div>
        <div class="list">
          <span>班级</span>
          <p>{{ noValue(userInfo.className) }}</p>
        </div>
        <div class="list">
          <span>电话</span>
          <p>{{ noValue(userInfo.phoneNumber) }}</p>
        </div>
        <div class="list">
          <span>邮箱</span>
          <p>{{ noValue(userInfo.email) }}</p>
        </div>
        <!-- <div class="list">
          <span>简介</span>
          <p>--</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualimitationIndex",

  data() {
    return {
      userInfo: {},
      role: -1,
      isLoading: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.userInfo = JSON.parse(localStorage.getItem("USER"));
      this.role = this.userInfo.type; //1 为学生 2
      this.isLoading = true;
    },300);
  },

  methods: {
    goNextRouter(path) {
      this.$router.push(path);
    },
    noValue(value) {
      return value ? value : "--";
    },
  },
};
</script>

<style lang="less" scoped>
.userInfo {
  width: 100%;
  .userInfo-content {
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 40px 38px;
    position: relative;
    .content-title {
      .content-title-left {
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #8e8e90;
          opacity: 1;
        }
        img {
          margin-top: 6px;
          display: block;
          width: 70px;
          height: 70px;
          border-radius: 50%;
        }
      }
      .content-title-right {
        position: absolute;
        top: 29px;
        right: 32px;
        width: 83px;
        height: 38px;
        border: 1px solid #1880fa;
        border-radius: 4px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #1880fa;
        }
      }
    }
    .content {
      margin-top: 30px;
      display: flex;
      justify-content: start;
      flex-wrap: wrap;
      .list {
        width: 33%;
        margin-bottom: 38px;
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #8e8e90;
          opacity: 1;
        }
        p {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #101012;
          opacity: 1;
          margin-top: 6px;
        }
      }
    }
  }
}
.addExperiment-title {
  margin-bottom: 16px;
  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    font-style: normal;
    opacity: 1;
  }
  span {
    color: #939393;
    cursor: pointer;
  }
}
</style>